export const RaceDescription = () => {
  return (
    <section className="race-description">
      <h2>The Loco Strikes Back: 9th Edition of the International Taco Bell 50k Ultramarathon</h2>
      <p>
        It has been described as Urban Legend. More mysterious and barking
        spiders than the Barkley Marathons. The International Taco Bell 50k
        boasts a higher DNF rate than the famed Leadville 100 Trail Race.
        As the tale is told, the race began with a hot tub, a stoic Russian,
        a short king from New York, and Susie. The race has been held annually
        in Denver, Colorado in early October, which coincidentally coincides
        with International Taco Day. It is a good idea to engage in gastric
        training. If you complete the challenge, you will be deemed a SURVIVOR,
        revered and heckled for life!
      </p>
      
    </section>
  );
};
